const V = {};

export { V };
